import React, { useRef, useEffect, useState } from "react";
import styles from "./HeroSectionStatic.module.css";
import Button from "../../Button/Button";
import logoLeftHalf from "../../../assets/images/logo-left-half.svg";
import LogosScroll from "../LogosScroll/LogosScroll";

interface HeroSectionProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  heroButtons?: Array<{
    label: React.ReactNode;
    variant: string;
    onClick?: () => void;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
  }>;
  clutchImages?: Array<{
    image: React.ReactNode;
    link?: string;
  }>;
  heroLottieAnimation?: any;
  heroStaticSvg?: string;
  small?: boolean;
}

const HeroSectionStatic: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  heroButtons = [],
  clutchImages = [],
  small = false,
}) => {

  const renderHeroContent = () => {
    return (
      <div className={styles.animationContainer}>
        <div className={styles.animationInner}>
          <img className={styles.logoImage} src={logoLeftHalf} alt="Logo left half" />
        </div>
      </div>
    );
  };

  return (
    <section className={`${styles.heroSection}`}>
      <div className={`${styles.heroContent} ${small ? styles.small : ""}`}>
        <div className={styles.heroGraphic}>{renderHeroContent()}</div>

        <div className={styles.leftContent}>
          <h1 className={styles.heroTitle}>{title}</h1>
          <p className={styles.heroSubtitle}>{subtitle}</p>
          {heroButtons.length > 0 && (
            <div className={styles.heroButtons}>
              {heroButtons.map((button, index) => (
                <Button
                  key={index}
                  variant={
                    button.variant as
                    | "primary"
                    | "secondary"
                    | "outline"
                    | "outlineNoTheme"
                    | "text"
                    | "text-underline"
                  }
                  onClick={button.onClick}
                  leftIcon={button.leftIcon}
                  rightIcon={button.rightIcon}
                  className={styles.heroButton}
                >
                  {button.label}
                </Button>
              ))}
            </div>
          )}
          {clutchImages.length > 0 && (
            <div className={styles.clutchDiv}>
              {clutchImages.map((clutchImage, index) => (
                <div key={index} className={styles.clutchImage}>
                  {clutchImage.link ? (
                    <a href={clutchImage.link} target="_blank" rel="noopener noreferrer">
                      {clutchImage.image}
                    </a>
                  ) : (
                    clutchImage.image
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={styles.rightContent}>{renderHeroContent()}</div>
      </div>
      <LogosScroll />
    </section>
  );
};

export default HeroSectionStatic;
